<slotcom-two-column-layout
  [event]="progressbag()"
  [infoModal]="NonPersistedModalName.ProgressbagInfoModalComponent"
  [modalName]="NonPersistedModalName.ProgressbagModalComponent">
  <ng-container left-container>
    <div class="left-column">
      <div
        class="event-icon"
        theming
        themingGroup="progressivebag"
        themingAsset="logo"
        [themingOverride]="progressbag()?.assets"></div>
      <div class="event-info">
        <span class="green-text M">{{ 'home.live-ops.progressbag.text' | translate }}</span>
        <span
          class="icon-text"
          theming
          themingGroup="progressivebag"
          themingAsset="icon-points"
          [themingOverride]="progressbag()?.assets"></span>
        <span class="green-text M">{{
          'home.live-ops.progressbag.text-2'
            | translate
              : {
                  maxprize: maxReward() | number: '1.0-0' : ('common.culture' | translate)
                }
        }}</span>
        <p class="green-text M nomargin">
          {{ 'home.live-ops.progressbag.text-3' | translate }}
        </p>
        <br />
        <p class="green-text S narrow">
          {{ 'home.live-ops.progressbag.text-4' | translate }}
        </p>
      </div>
      <div class="event-timer">
        <div class="green-text XS light">
          {{ 'home.live-ops.global.time-left' | translate }}
        </div>
        <div class="timer-display">
          <slotcom-animated-timer
            [showInDays]="true"
            [endDate]="progressbag().endDate"
            (expired)="closeModal()"></slotcom-animated-timer>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container right-container>
    <div class="right-column">
      <div class="event-title">
        <div class="green-text L bold">
          {{
            progressbag().principalTitleText[lang()]
              ? (progressbag().principalTitleText[lang()] | uppercase)
              : ('home.live-ops.progressbag.title' | translate | uppercase)
          }}
        </div>
        @if (progressbag().secondaryTitleText[lang()]) {
          <div class="green-text L bold">
            {{ progressbag().secondaryTitleText[lang()] | uppercase }}
          </div>
        } @else {
          <div class="green-text L bold">
            {{ 'home.live-ops.progressbag.title-2' | translate | uppercase }}
          </div>
        }
      </div>
      <div class="event-progress">
        <div class="event-progress-content">
          <div class="progress-box-container">
            <div class="progress-box">
              <div class="box-upper-section">
                <div class="green-text XXS">
                  {{ 'home.live-ops.progressbag.current-reward' | translate | uppercase }}
                </div>
                <div class="reward-container">
                  <div class="coin-icon"></div>
                  <div class="green-text ML">
                    {{ currentPrize() | beautifyNumber: ('common.culture' | translate) }}
                  </div>
                </div>
              </div>
              <div class="box-lower-section">
                <div class="green-text XXS">
                  {{ 'home.live-ops.progressbag.points-achieved' | translate | uppercase }}
                </div>
                <div class="points-container">
                  <div
                    class="points-icon"
                    theming
                    themingGroup="progressivebag"
                    themingAsset="icon-points"
                    [themingOverride]="progressbag()?.assets"></div>
                  <div class="green-text ML">
                    {{ progressbag().current | number: '1.0-0' : ('common.culture' | translate) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="progress-asset-container">
            <slotcom-animated-asset
              class="progress-asset"
              [progressStep]="progressbagTreeStep()"
              [event]="progressbag()"></slotcom-animated-asset>
          </div>
          <div class="progress-juliet-container">
            <div
              class="progress-juliet"
              theming
              themingGroup="progressivebag"
              themingAsset="juliet-farmer"
              [themingOverride]="progressbag()?.assets"></div>
          </div>
        </div>
        <div class="event-progress-bar">
          <div
            class="bar-background"
            theming
            themingGroup="progressivebag"
            themingAsset="box-progressive"
            [themingOverride]="progressbag()?.assets"></div>
          <div class="bar-elements">
            <div class="bar-progressive">
              <slotcom-progressbag-progress-bar
                [animated]="showAnimations()"
                [event]="progressbag()"
                [pointsPerBagMultiplier]="progressbag().properties.pointsperbagmultiplier"
                [currentProgress]="points()"
                [totalProgress]="progressbag().total"
                [stepIcon]="stepIcon()"
                [finalIcon]="finalIcon()">
                <span
                  eventProgressBarIcon
                  eventProgressBarIconPos="left"
                  theming
                  themingGroup="progressivebag"
                  themingAsset="icon-points"
                  [themingOverride]="progressbag()?.assets"
                  class="type-icon"></span>
              </slotcom-progressbag-progress-bar>
            </div>
            <div class="bar-text">
              @if (progressbag().current >= progressbag().total) {
                <div>
                  <div class="green-text XS bold completed">
                    <div>
                      {{ 'home.live-ops.progressbag.subtitle-3' | translate }}
                    </div>
                    <div>
                      {{ 'home.live-ops.progressbag.subtitle-4' | translate }}
                    </div>
                  </div>
                </div>
              } @else {
                <div class="green-text XS bold">
                  <span>{{
                    'home.live-ops.progressbag.subtitle'
                      | translate
                        : {
                            points: pointsDifference() | number: '1.0-0' : ('common.culture' | translate)
                          }
                  }}</span>
                  <span
                    class="icon-text"
                    theming
                    themingGroup="progressivebag"
                    themingAsset="icon-points"
                    [themingOverride]="progressbag()?.assets"></span>
                  <span>{{ 'home.live-ops.progressbag.subtitle-2' | translate }}</span>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="event-progress-buttons">
          <slotcom-button
            class="c-button--purple"
            (safeClick)="openInfo2()"
            audioType="functionality">
            {{ 'home.buttons.how-get-points' | translate | uppercase }}
          </slotcom-button>
          <slotcom-button
            class="c-button--pink"
            (safeClick)="openShop()"
            audioType="functionality">
            {{
              progressbag().statusCultureButtonText[lang()]
                ? progressbag().statusCultureButtonText[lang()]
                : ('home.buttons.for-points' | translate | uppercase)
            }}
          </slotcom-button>
        </div>
      </div>
    </div>
  </ng-container>
</slotcom-two-column-layout>
